import { connect } from 'react-redux'
import { IResetPasswordDispatchProps, IResetPasswordProps, ResetPassword } from './ResetPassword'
import { resetPassword } from './store/ResetPasswordActions'
import { doLogOut } from '../../common/auth/authActions'
import {
  getUserCompanies,
  getUserDto,
  isAuthenticated,
  isResetPasswordInProgress,
} from '../../common/auth/authSelectors'
import { IGlobalState } from '../../Root/store/appReducer'

const mapStateToProps = (state: IGlobalState): IResetPasswordProps => ({
  authenticated: isAuthenticated(state),
  resetPasswordInProgress: isResetPasswordInProgress(state),
  email: getUserDto(state)?.email || '',
  userCompanies: getUserCompanies(state) || [],
})

const mapDispatchToProps: IResetPasswordDispatchProps = {
  resetPassword,
  doLogOut,
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
